import { useEffect, useRef, useState } from 'react'
import { TickerIcon } from './chart.styles'

/**
 * Tries each icon in turn and hides itself when none loads. An image can fail before
 * hydration attaches `onError`, so the mounted element is checked once as well. Both
 * paths can report the same failure, so each only moves on from the icon it saw fail.
 */
interface TokenIconProps {
  sources: string[]
  size?: 28 | 32
  /** No white ring around the logo. */
  bare?: boolean
}

export const TokenIcon = ({ sources, size = 28, bare }: TokenIconProps) => {
  const [index, setIndex] = useState(0)
  const ref = useRef<HTMLImageElement>(null)
  const src = sources[index]
  const skip = (failed: number) => setIndex((current) => (current === failed ? failed + 1 : current))

  useEffect(() => {
    const img = ref.current
    if (img?.complete && img.naturalWidth === 0) skip(index)
  }, [index])

  if (!src) return null
  return <TickerIcon ref={ref} src={src} alt="" $size={size} $bare={bare} onError={() => skip(index)} />
}
